"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Search_1 = __importDefault(require("../icons/Search"));
function NoResults(_a) {
    var noResultsQuery = _a.noResultsQuery;
    return (react_1.default.createElement("div", { className: "flex gap-8 text-blue-6 t-body-sm" },
        react_1.default.createElement("span", { className: "leading-6" },
            react_1.default.createElement(Search_1.default, null)),
        react_1.default.createElement("span", null,
            "No results found for \"",
            noResultsQuery.toLowerCase(),
            "\", try a different search")));
}
exports.default = NoResults;
//# sourceMappingURL=NoResults.js.map